import util from "util";

export const getEveryDayMap = (startDateObj, endDateObj, excludeDaysOfWeek = []) => {
    let allDateMap = {};


    //add in first
    if (!excludeDaysOfWeek.includes(startDateObj.getDay())) {
        allDateMap[toDateStr(startDateObj)] = true;
    }

    //add in rest
    while (startDateObj.getTime() < endDateObj.getTime()) {
        startDateObj = new Date(startDateObj.getTime() + 86400000);
        if (!excludeDaysOfWeek.includes(startDateObj.getDay())) {
            allDateMap[toDateStr(startDateObj)] = true;
        }
    }

    return allDateMap;
}

export const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const monNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const dateStrToDateObj = dateStr => new Date(dateStr + "T12:00:00")
export const nextDateStr = dateStr => {
    const dateObj = dateStrToDateObj(dateStr);
    dateObj.setDate(dateObj.getDate() + 1)
    return toYYYYMMDD(dateObj)
}
export const prevDateStr = dateStr => {
    const dateObj = dateStrToDateObj(dateStr);
    dateObj.setDate(dateObj.getDate() - 1)
    return toYYYYMMDD(dateObj)
}
export const today = () => {
    const today = new Date();
    today.setHours(today.getHours() - 2);
    return toDateStr(today)
}
export const sixWeeks = () => {
    const today = new Date();
    today.setDate(today.getDate() + 42);
    return toDateStr(today)
}
export const toDateStr = (dateObj) => util.format("%s-%s-%s",dateObj.getFullYear(), (dateObj.getMonth() + 1).toString().padStart(2, "0"), dateObj.getDate().toString().padStart(2,"0" ));
export const toYYYYMMDD = (dateObj) => util.format("%s-%s-%s",dateObj.getFullYear(), (dateObj.getMonth() + 1).toString().padStart(2, "0"), dateObj.getDate().toString().padStart(2,"0" ));
export const toHHMM = (dateObj) => util.format("%s:%s",dateObj.getHours().toString().padStart(2,"0"), dateObj.getMinutes().toString().padEnd(2,"0"));
export const dateToHumanDateStr = dateObj => dayNames[dateObj.getDay()] + ", " + monNames[dateObj.getMonth()] + " " + dateObj.getDate();
export const display24HourTime = time => {
    let [h,m] = time.split(":")
    h = parseInt(h)
    if (h > 12) {
        h = h % 12
        if (h === 0) {
            h = 12
        }
    }
    if (m === "00") {
        m = ""
    } else {
        m = ":" + m
    }
    let timeStr = h.toString() + m
    if (timeStr === "11:55") {
        timeStr = 12
    }
    return timeStr
}
const slashDateRE = /^(\d+)\/(\d+)\/(\d+)$/

// convert 5/15/2025 to 2025-05-15
export const slashDateToOrderedDate = (str) => {
    const [,month,day,year] = slashDateRE.exec(str)
    return util.format("%s-%s-%s", year, padMD(month), padMD(day))
}
// pad month and day number and stringify
const padMD = (num) => num.toString().padStart(2, "0")

const hour12TimeRE = /(\d+):?(\d*)\s*(p|a)?/i
export const convert12Hourto26hour = str => {
    let [, hour, minute, ap] = hour12TimeRE.exec(str)
    if (ap.toLowerCase() !== "a" && hour !== "12") {
        hour = parseInt(hour) + 12
    }
    return util.format("%s:%s", padMD(hour), padMD(minute))
}